import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=f6b0c7dc"
import script from "./Rating.vue?vue&type=script&lang=ts"
export * from "./Rating.vue?vue&type=script&lang=ts"
import style0 from "./Rating.vue?vue&type=style&index=0&id=f6b0c7dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports